/** Короткий мягкий сигнал о новом сообщении (без внешних файлов). */
export function playMessageBeep(): void {
  try {
    const Ctx = window.AudioContext || (window as any).webkitAudioContext
    if (!Ctx) return
    const ctx = new Ctx()
    const o = ctx.createOscillator()
    const g = ctx.createGain()
    o.type = "sine"
    o.frequency.value = 880
    g.gain.value = 0.04
    o.connect(g)
    g.connect(ctx.destination)
    o.start()
    window.setTimeout(() => {
      o.stop()
      ctx.close().catch(() => {})
    }, 140)
  } catch {
    // ignore
  }
}
